import { useState, useEffect, useCallback } from "react";

const KEY = "woma_cart";
const EVT = "woma-cart-change";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

const write = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVT));
};

export const cartTotal = (items) => items.reduce((s, i) => s + i.price * i.quantity, 0);

export function useCart() {
  const [items, setItems] = useState(read);

  useEffect(() => {
    const sync = () => setItems(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  // Retourne false si le produit vient d'une autre boutique que le panier actuel
  const add = useCallback((product) => {
    const cur = read();
    if (cur.length && cur[0].vendor_id !== product.vendor_id) return false;
    const found = cur.find((i) => i.product_id === product.id);
    const max = 99;
    const next = found
      ? cur.map((i) => (i.product_id === product.id ? { ...i, quantity: Math.min(max, i.quantity + 1) } : i))
      : [...cur, {
          product_id: product.id, name: product.name, price: product.price,
          image_url: product.image_url, vendor_id: product.vendor_id,
          shop_id: product.shop_id, quantity: 1,
        }];
    write(next);
    return true;
  }, []);

  const setQty = useCallback((productId, qty) => {
    const next = read()
      .map((i) => (i.product_id === productId ? { ...i, quantity: Math.min(99, qty) } : i))
      .filter((i) => i.quantity > 0);
    write(next);
  }, []);

  const clear = useCallback(() => write([]), []);

  return { items, add, setQty, clear, total: cartTotal(items), count: items.reduce((s, i) => s + i.quantity, 0) };
}
